/**
 * Created by quikr on 1/4/17.
 */
import React, {PropTypes} from "react";
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import {OverlayTrigger, Tooltip, Popover} from "react-bootstrap";
import toastr from "toastr";
import ProfilePhoto from "../../../components/common/ProfilePhoto";


function columnClassNameFormat(fieldValue, row, rowIdx, colIdx) {
  switch (row.empStatus) {
    case 'I':
      return 'color3';
    case 'P':
      return 'color5';
    case  'F':
      return 'blue';
    default:
      return '';
  }

}
function dateFormat(cell) {

  if (cell != null && cell != 'NA' && cell != 0)
    return <font>{cell.toDateString()}</font>
  else
    return 'NA';

}
class ExitTable extends React.Component {

  constructor() {
    super();
    this.state = {};
  }

  renderShowsTotal(start, to, total) {
    return (
      <p style={ {color: 'black'} }>
        From { start } to { to }, total entries { total }
      </p>
    );
  }

  checkNull(cell, row, formatExtraData, rowIdx) {
    if (cell == null || cell == undefined || cell == "") {
      return 'NA';
    }
    else return cell;
  }


  render() {
    const departmentType = {
      "Ad Sales": "Ad Sales",
      "Admin": "Admin",
      "Analytics": "Analytics",
      "Application Development": "Application Development",
      "At home beauty service": "At home beauty service",
      "Back Office": "Back Office",
      "BEAUTY": "BEAUTY",
      "Branch Sales": "Branch Sales",
      "Business Development": "Business Development",
      "Business Intelligence": "Business Intelligence",
      "C2C": "C2C",
      "Car & Bike Services": "Car & Bike Services",
      "Carnation": "Carnation",
      "CEO Office": "CEO Office",
      "Channel Partners": "Channel Partners",
      "Content Creation": "Content Creation",
      "Content Moderation": "Content Moderation",
      "Content Review": "Content Review",
      "Corporate Sales": "Corporate Sales",
      "Customer Service": "Customer Service",
      "Customer Support": "Customer Support",
      "Delivery Ops": "Delivery Ops",
      "Delivery Ops - VL": "Delivery Ops - VL",
      "Design": "Design",
      "Digital Marketing": "Digital Marketing",
      "Direct Sales": "Direct Sales",
      "Domain Research": "Domain Research",
      "Doorstep": "Doorstep",
      "Education": "Education",
      "Engineering": "Engineering",
      "Executive Assistant": "Executive Assistant",
      "FINANCE": "FINANCE",
      "Finance and Accounts": "Finance and Accounts",
      "Google Adwords": "Google Adwords",
      "Groups": "Groups",
      "HIREE": "HIREE",
      "HomeVision": "HomeVision",
      "HR": "HR",
      "Human Resource": "Human Resource",
      "Human Resources": "Human Resources",
      "Implementation": "Implementation",
      "Inspection": "Inspection",
      "IRX": "IRX",
      "IT": "IT",
      "IT Infra": "IT Infra",
      "Jobs": "Jobs",
      "Listing Operations": "Listing Operations",
      "Marketing": "Marketing",
      "MGMT": "MGMT",
      "MIS": "MIS",
      "Mobile Development": "Mobile Development",
      "Mobile Exchange": "Mobile Exchange",
      "Offline Content": "Offline Content",
      "oms": "oms",
      "On-Demand Services": "On-Demand Services",
      "online": "online",
      "operation": "operation",
      "Operations": "Operations",
      "PKHD": "PKHD",
      "PLV": "PLV",
      "Product": "Product",
      "Product Monetization": "Product Monetization",
      "Product Operations": "Product Operations",
      "Public Relations": "Public Relations",
      "QA": "QA",
      "Quality": "Quality",
      "Quikr Cars": "Quikr Cars",
      "Quikr Education": "Quikr Education",
      "Quikr Education Sales": "Quikr Education Sales",
      "Quikr Homes": "Quikr Homes",
      "QUIKR JOBS": "QUIKR JOBS",
      "Quikr Service": "Quikr Service",
      "Quikr Services": "Quikr Services",
      "Quikr Services (Groups)": "Quikr Services (Groups)",
      "quikr services (Sales)": "quikr services (Sales)",
      "Quikr X": "Quikr X",
      "Quikrjob": "Quikrjob",
      "Quirk Cars": "Quirk Cars",
      "RE Sales": "RE Sales",
      "RE-Quality": "RE-Quality",
      "Real Estate": "Real Estate",
      "Reality Redefined": "Reality Redefined",
      "Recovery": "Recovery",
      "Renewal": "Renewal",
      "Renewals": "Renewals",
      "Retail": "Retail",
      "Retention": "Retention",
      "Sales": "Sales",
      "Sales Analytics": "Sales Analytics",
      "Sales jobs": "Sales jobs",
      "Sales Operations": "Sales Operations",
      "sales qukr jobs": "sales qukr jobs",
      "Sales Support": "Sales Support",
      "Sales- Car & Bike": "Sales- Car & Bike",
      "Sales-Quikr Services": "Sales-Quikr Services",
      "SELLS": "SELLS",
      "service": "service",
      "Service Provider Operations": "Service Provider Operations",
      "Service Seeker Operations": "Service Seeker Operations",
      "Services": "Services",
      "Services sales": "Services sales",
      "Social Media": "Social Media",
      "Stylist": "Stylist",
      "System Admin": "System Admin",
      "TALLY SALES": "TALLY SALES",
      "Tech": "Tech",
      "Technology": "Technology",
      "Tele Sales": "Tele Sales",
      "Telecalling": "Telecalling",
      "TeleSales": "TeleSales",
      "Trainer": "Trainer",
      "UED": "UED",
      "Video Production": "Video Production",
      "Web Development": "Web Development"
    }
    const locationType = {
      "Ahmedabad": "Ahmedabad",
      "Bangalore": "Bangalore",
      "Chandigarh": "Chandigarh",
      "Chennai": "Chennai",
      "Coimbatore": "Coimbatore",
      "Delhi": "Delhi",
      "Dwarka": "Dwarka",
      "Gurgaon": "Gurgaon",
      "Hyderabad": "Hyderabad",
      "Jaipur": "Jaipur",
      "Kolkata": "Kolkata",
      "Lucknow": "Lucknow",
      "Mumbai": "Mumbai",
      "MYSORE": "MYSORE",
      "New Delhi": "New Delhi",
      "Noida": "Noida",
      "Rajasthan": "Rajasthan",
      "Surat": "Surat",
      "Vadodara": "Vadodara"

    };

    const payrollType = {
      'Quikr': 'Quikr',
      'Team Lease': 'Team Lease'
    };
    const statusType = {
      'R': 'R',
      'I': 'I'
    };
    const toeType = {
      'Involuntary': 'Involuntary',
      'Voluntary': 'Voluntary'
    }
    const noeType = {
      'Serving': 'Serving',
      'Waived_Off': 'Waived Off',
      'Gardening': 'Gardening'
    }
    const runningStatusType = {
      'pending': 'Pending',
      'Completed': 'Completed'

    }

    const options = {
      clearSearch: true,

      sizePerPageList: [10, 20, 30, 40, 200],
      paginationShowsTotal: this.renderShowsTotal// Enable showing total text
    };

    return (
      <div >
        <BootstrapTable
          containerStyle={{borderBottomStyle: 'solid', borderColor: '#428BCA', borderWidth: '1px'}}
          headerStyle={{
            borderTopStyle: 'solid', borderTopColor: 'rgb(92, 184, 92)', borderWidth: '1px'
            , borderBottomStyle: 'solid', borderBottomColor: '#428BCA'
          }}
          tableStyle={{marginBottom: '5%', borderStyle: 'solid'}}

          data={this.props.employees}
          search={true}
          striped
          options={options}
          pagination>
          <TableHeaderColumn

            isKey={false}
            hidden={false}
            columnClassName="leftRightZero"
            width={60}
            style={{paddingRight: 0}}
            dataFormat={(cell, row)=> {
              //if P -> Approve
              if (row.empStatus == 'P' || row.vhStatus == "pending")
                return <div >
                  <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">Approve/Withdraw</Tooltip>}>
                    <img
                      style={{cursor: 'pointer'}}
                      onClick={()=> {
                        this.props.edit(row);
                        this.props.openApprove();
                        return;
                      }}
                      src="/public/images/success.png"></img>
                  </OverlayTrigger></div>
              if (row.doLeaving != null) {
                let dol = new Date(row.doLeaving), todayDate = new Date();
                if (((dol.getDate() == todayDate.getDate() && dol.getDay() == todayDate.getDay()) || dol < todayDate) && row.managerStatus == 'pending')
                  if (row.empStatus != 'P') {
                    if (row.empStatus == 'I')
                      return <div>
                        <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">Confirm Exit</Tooltip>}>
                          <img
                            style={{cursor: 'pointer'}}
                            onClick={()=> {
                              this.props.edit(row);
                              this.props.openConfirm();
                            }}
                            src="/public/images/success.png"></img>
                        </OverlayTrigger>

                      </div>
                    else
                      return <div style={{paddingRight: 0, paddingBottom: 0}}>
                        <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">Edit</Tooltip>}>
                          <img
                            style={{cursor: 'pointer', paddingBottom: 0}}
                            onClick={()=> {
                              this.props.edit(row);
                              this.props.open();
                            }}
                            src="/public/images/edit.png"></img>
                        </OverlayTrigger>
                        <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">Confirm Exit</Tooltip>}>
                          <img
                            style={{paddingLeft: '15px', paddingBottom: 0, cursor: 'pointer'}}
                            onClick={()=> {
                              this.props.edit(row);
                              this.props.openConfirm();
                            }}
                            src="/public/images/success.png"></img>
                        </OverlayTrigger>
                      </div>

                  }
              }

              if (row.empStatus == 'P')
                return <div>
                  <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">Approve/Withdraw</Tooltip>}>
                    <img
                      style={{cursor: 'pointer'}}
                      onClick={()=> {
                        this.props.edit(row);
                        this.props.openApprove();
                        return;
                      }}
                      src="/public/images/edit.png"></img>
                  </OverlayTrigger></div>
              else if (row.empStatus == 'F' || row.empStatus == 'I')
                return <div>
                  <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">Inactive</Tooltip>}>
                    <img
                      style={{cursor: 'pointer'}}
                      onClick={()=> {
                        toastr.info("Employee is inactive");
                        return;
                      }}
                      src="/public/images/success2.png"></img>
                  </OverlayTrigger></div>;

              else
                return <div>
                  <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">Edit</Tooltip>}>
                    <img
                      style={{cursor: 'pointer'}}
                      onClick={()=> {
                        if (row.empStatus == "I") {
                          toastr.info("Employee is inactive");
                          return;
                        }

                        this.props.edit(row);
                        this.props.open();
                      }
                      }
                      src="/public/images/edit.png"></img>
                  </OverlayTrigger>

                </div>
            }}
            dataField="empId">Action</TableHeaderColumn>


          <TableHeaderColumn dataSort={true}
                             isKey={true}
                             hidden={false}
                             filter={ {type: 'TextFilter', delay: 0, placeholder: 'Id'} }
                             width={100}
                             columnClassName={ columnClassNameFormat }
                             dataField="employeeCode">Id</TableHeaderColumn>
          <TableHeaderColumn dataSort={true}
                             filter={ {type: 'TextFilter', delay: 0, placeholder: 'Name'} }
                             columnClassName={ columnClassNameFormat }
                             width={140} dataField="name"
                             dataFormat={(cell, row)=> {
                               return <OverlayTrigger trigger={['hover']} placement="top" overlay={<Popover>
                                 <ProfilePhoto height="150px" width="150px" empno={row.employeeCode}/></Popover>}>
                                 <a onClick={()=> {
                                   this.props.trueDisable();
                                   this.props.edit(row);
                                   this.props.openExit();
                                 } }
                                 >{cell}</a>
                               </OverlayTrigger>

                             }
                             }>Name</TableHeaderColumn>


          <TableHeaderColumn dataField="doR"
                             columnClassName={ columnClassNameFormat }
                             dataFormat={dateFormat}
                             dataSort={true}
                             width={120}>Date of<br/> Resignation</TableHeaderColumn>


          <TableHeaderColumn dataField="doL"
                             columnClassName={ columnClassNameFormat }
                             dataFormat={dateFormat}
                             dataSort={true}
                             width={120}>Last Working<br/>Day</TableHeaderColumn>

          <TableHeaderColumn dataSort={true}
                             columnClassName={ columnClassNameFormat }
                             filter={ {type: 'SelectFilter', options: noeType, placeholder: 'Notice Period Status'} }
                             dataFormat={this.checkNull}
                             width={150}
                             dataField="noticePeriodStatus">Notice Period<br/> Status</TableHeaderColumn>
          <TableHeaderColumn dataSort={true}
                             columnClassName={ columnClassNameFormat }
                             filter={ {type: 'SelectFilter', options: toeType, placeholder: 'Type Of Exit'} }
                             dataFormat={this.checkNull}
                             width={100}
                             dataField="type_of_exit">Type Of<br/>Exit</TableHeaderColumn>
          <TableHeaderColumn dataSort={true}
                             columnClassName={ columnClassNameFormat }
                             filter={ {type: 'SelectFilter', options: statusType, placeholder: 'Status'} }
                             dataFormat={this.checkNull}
                             width={80}
                             dataField="empStatus">Status</TableHeaderColumn>


        </BootstrapTable>

      </div>
    );
  }
}

ExitTable.propTypes = {};

export default ExitTable;






/** WEBPACK FOOTER **
 ** ./src/feature/myProfile/Exit/ExitTable.js
 **/